import { useEffect, useState } from "react"
import { getLocalidadById, postLocalidad, patchLocalidad, getAllProvincias } from "../../services/LocalidadesServices"
import { LocalidadesFormContext } from "./LocalidadesContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const LocalidadesFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const [provinciasData, setProvinciasData] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        getAllProvinciasData()
        if (id) getLocalidadByIdData(id)
    }, [])

    const getLocalidadByIdData = async (id) => {
        let res = await getLocalidadById(id)
        
        if (res) setReport(res)
    }

    const getAllProvinciasData = async (id) => {
        let res = await getAllProvincias(id)
        setProvinciasData(res)
    }

    const postLocalidadData = async (body) => {
        const res = await postLocalidad(body)
        
        if (res) navigate("/localidades");
    }

    const patchLocalidadData = async (id, body) => {
        const res = await patchLocalidad(id, body)

        if (res) navigate("/localidades");
    }


    return <LocalidadesFormContext.Provider value={{
        report,
        provinciasData,
        postLocalidadData,
        patchLocalidadData,
        getAllProvinciasData
    }} >
        {children}
    </LocalidadesFormContext.Provider>
}